<template>
  <el-dialog
    :visible="true"
    title="编辑任务分配"
    width="50%"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" class="ruleForm">
      <el-form-item label="任务月度">
        <el-input v-model="rowData.taskMonth" placeholder="任务月度" disabled></el-input>
      </el-form-item>
      <el-form-item label="结算单价（税前）" v-if="projectType!==19">
        <div style="display:flex;">
          <el-input v-model="price" placeholder="结算单价（税前）" disabled></el-input>元
        </div>
      </el-form-item>
      <el-form-item label="计划结算金额（税前）">
        <div style="display:flex;">
          <template v-if="projectType!==19">
            <el-input v-model="finishSum" placeholder="计划结算金额（税前）" disabled></el-input>元
          </template>
          <template v-else>
            <el-input v-model="finishSum" placeholder="计划结算金额（税前）"></el-input>元
          </template>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm('ruleForm', 1)">提交</el-button>
      <el-button @click="close">返回</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { bingli } from "@/api/ajax";
import { getToken } from "@/tools/auth";
import { isInteger } from "@/tools/formCheck";
import Config from "@/config/index";
export default {
  props: {
    rowData: {
      type: Object,
      default: {}
    },
    projectType: {
      type: Number
    }
  },
  data () {
    return {
      price: this.rowData.price / 100,
      ruleForm: {
        type: "",
        id: this.rowData.id,
        taskSum: this.rowData.taskSum || 0,
        price: this.rowData.price
      },
      rules: {
        taskSum: [
          {
            required: true,
            validator: isInteger,
            trigger: "blur"
          }
        ]
      }
    };
  },
  components: {},
  watch: {},
  computed: {
    finishSum () {
      return (this.ruleForm.taskSum * this.rowData.price) / 100;
    }
  },
  methods: {
    confirm (formName, type) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.type = type;
          this.$parent.submitAjax(this.ruleForm).then(res => {
            this.$emit("task-close", false);
            this.$parent.initWatchRouteChange();
          });
        }
      });
    },
    close () {
      this.$emit("task-close", false);
    }
  },
  created () { },
  beforeDestroy () { }
};
</script>

<style scoped lang="scss"></style>
